import {
  BackofficeDetailPromoItemWithDiscount,
  BackofficeDetailPromoItemWithFreeGoods,
  GroupedPromoItem,
} from '@diamond/shared/types';

export const isFreeGoods = (
  data: GroupedPromoItem[] | null | undefined
): data is BackofficeDetailPromoItemWithFreeGoods[] =>
  !!data && data.length > 0 && 'product_free_good' in data[0];

export const isDiscount = (
  data: GroupedPromoItem[] | null | undefined
): data is BackofficeDetailPromoItemWithDiscount[] =>
  !!data && data.length > 0 && 'product_discount' in data[0];
